import { PhoneApps } from '~/shared';
import { PhoneAds } from '../views/PhoneAds';
import { PhoneBank } from '../views/PhoneBank';
import { PhoneContacts } from '../views/PhoneContacts';
import { PhoneGPS } from '../views/PhoneGPS';
import { PhoneMain } from '../views/PhoneMain';
import { PhoneMessenger } from '../views/PhoneMessenger';
import { PhonePhone } from '../views/PhonePhone';
import { PhonePhotos } from '../views/PhonePhotos';
import { PhoneSettings } from '../views/PhoneSettings';

export const appComponents = {
	[PhoneApps.MAIN]: PhoneMain,
	[PhoneApps.MESSENGER]: PhoneMessenger,
	[PhoneApps.CAMERA]: null,
	[PhoneApps.GPS]: PhoneGPS,
	[PhoneApps.BANK]: PhoneBank,
	[PhoneApps.SETTINGS]: PhoneSettings,
	[PhoneApps.CONTACTS]: PhoneContacts,
	[PhoneApps.PHONE]: PhonePhone,
	[PhoneApps.PHOTOS]: PhonePhotos,
	[PhoneApps.ADS]: PhoneAds,
};
